import { Expose, Type } from "class-transformer";
import { IsArray, IsBoolean, IsNumber, IsString, ValidateNested, IsDateString, IsOptional } from "class-validator";
import GenericTableResponse from "@/models/api/GenericTableResponse";

export class ExchangeRateItems {
  @IsOptional()
  @IsNumber()
  @Expose()
  exchangeRateId!: number | null;
  @IsOptional()
  @IsString()
  @Expose()
  currencyCode!: string | null;
  @IsOptional()
  @IsString()
  @Expose()
  currencyName!: string | null;
  @IsDateString()
  @Expose()
  exchangeDate!: Date | string;
  @IsNumber()
  @Expose()
  exchangeRateValue!: number;
  @IsOptional()
  @IsString()
  @Expose()
  tableNumber!: string | null;
  @IsString()
  @Expose()
  provider!: string;
  @IsBoolean()
  @Expose()
  isManualAdd!: boolean;
}

export class ExchangeRateItemsAdd {
  @IsOptional()
  @IsString()
  @Expose()
  currencyCode!: string | null;
  @IsDateString()
  @Expose()
  exchangeDate!: Date | string;
  @IsNumber()
  @Expose()
  exchangeRateValue!: number;
  @IsOptional()
  @IsString()
  @Expose()
  tableNumber!: string | null;

  constructor(currencyCode: null | string = "") {
    this.currencyCode = currencyCode;
    this.exchangeDate = new Date(new Date().setDate(new Date().getDate() - 1)).toJSON().substring(0, 10);
  }
}

export class ExchangeRateItemsResponse extends GenericTableResponse<ExchangeRateItems> {
  @Expose()
  @IsArray()
  @Type(() => ExchangeRateItems)
  @ValidateNested()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<ExchangeRateItems>;
}
